export enum StatisticsType {
    statistics = 'statistics',
    tables = 'tables',
    h2h = 'h2h',
    cupRoster = 'cupRoster',
    lineups = 'lineups',
    matchDetails = 'matchDetails',
}

export enum StreamState {
    NotAvailable = 'NotAvailable',
    NotStarted = 'NotStarted',
    Loading = 'Loading',
    Playing = 'Playing',
    Closed = 'Closed',
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/store/modules/ui/sportOffer/enums.ts